module.exports = __webpack_public_path__ + "static/img/2底盘线控化.aa00c98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案/农机无人驾驶解决方案/2底盘线控化.png
// module id = K8h2
// module chunks = 0